export const generatePhone = (phone: string | undefined): string => {
  if (!phone || phone === "+") {
    return "";
  }

  return phone;
};
